import React, { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import FieldDTOWithCol from '../Abstract/FieldDTOWithCol';
import CustomRegistryNumberSelector from './CustomRegistryNumberSelector';
import { Button } from '../../base/BootstrapComponents/BootstrapComponents';

export function MultipleRegistryNumberSelector(props) {
  const {
    loadAction = () => {},
    formMeta,
    onSelectNumber,
    title = 'Номера разрешений в реестре',
    inputProps = null,
    getFieldState = () => {},
    fieldState = {
      error: '',
      touched: false,
    },
    labelPrefix = '',
    dtoObject = {},
  } = props;

  const { error } = fieldState;
  const { value, onChange } = inputProps;
  // const dto = new ApplicationsDTO();
  // const attributes = dto.getAttributesByName();
  const { control, watch } = useForm({
    defaultValues: {
      numbers: value?.length ? value.map(v => ({ number: v })) : [{ number: '' }],
    },
  });
  const { fields, append, remove } = useFieldArray({ control, name: 'numbers', rules: { minLength: 1 } });
  useEffect(() => {
    const subscription = watch(values => {
      const v = values.numbers.map(n => n.number);
      onChange(v);
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  return (
    <div className="form-list-block">
      <div className="form-list-header f4 mt-3">
        {title}
        <Button
          variant="link"
          onClick={() => append('')}
        >
          Добавить запись
        </Button>
      </div>
      {error?.message ? (<div className="invalid-feedback d-block mt-1">{error?.message}</div>) : null }
      {fields.map((field, index) => {
        const fieldState = getFieldState(`numbers.${index}`);
        return (
          <div className="carrier-szlt-registry mt-3" key={field.id}>
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={CustomRegistryNumberSelector}
              dtoObject={{
                ...dtoObject,
                name: `numbers.${index}.number`,
                labelKey: `${labelPrefix}${dtoObject?.labelKey}`,
              }}
              variant="material"
              withLabel
              loadAction={loadAction}
              onSelectNumber={!index ? onSelectNumber : () => {
              }}
              optionFormatter={item => ({ value: item.number, name: item.number })}
              customMetaName="numbers"
              fieldState={fieldState}
            />
            <div className="d-flex flex-row align-items-center">
              {fields.length > 1 && (
                <Button className="mt-3 ms-auto btn-link" onClick={() => remove(index)}>Удалить
                  запись
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
